const Colors = {
	white : '#FFFFFF',
	black : '#000000',
	darkgray : '#333333',
	gray : '#5D5D5D',
	lightgray : '#96979c',
	// Basic colors
	green : '#C2E15F',
	orange : '#FDA333',
	purple : '#D3A4F9',
	red : '#FB4485',
	blue : '#6CE0F1',
	// Text colors

	// Awesome colors
	awesomeEmerald : '#00A388',
	awesomeSkyblue : '#0395DE',
	awesomeRed : '#DC3522',
	awesomeLightRed: '#FC746D',
	awesomePink : '#EF4089',
	awesomeOrange : '#FF6138',
	awesomeNephritis : '#27AE60',
	awesomeConcrete : '#95A5A6',
	awesomeDarknight : '#131A28',
	darktext : '#414141'
}
	
const Theme = {
	bgDarkTop: '#222233',
	bgLightTop: 'rgb(255, 252, 201, 1)',
	textDarkPrimaryTop: 'rgba(255,255,255,0.95)',
	textLightPrimaryTop: 'rgb(0, 0, 0, 0.80)',
	textDarkSecondaryTop: 'rgba(255,255,255,0.60)',
	textLightSecondaryTop: 'rgba(0,0,0,0.70)',
	textDarkTerciaryTop: '#ABCDFF',
	textLightTerciaryTop: Colors.awesomeRed,

	bgDarkBottom: '#222233',
	bgLightBottom:'rgb(255, 252, 201, 1)',
	textDarkPrimaryBottom: 'rgba(255,255,255,0.95)',
	textLightPrimaryBottom: 'rgb(0, 0, 0, 0.80)',
	textDarkSecondaryBottom: 'rgba(255,255,255,0.60)',
	textLightSecondaryBottom: 'rgba(0,0,0,0.70)',
	textDarkTerciaryBottom: '#ABCDFF',
	textLightTerciaryBottom: Colors.awesomeRed,

	bgDarkMain: '#2A2A3F',
	bgLightMain: 'rgb(255, 252, 201, 0.3)',
	textDarkPrimaryMain: 'rgba(255,255,255,0.95)',
	textLightPrimaryMain: 'rgb(0, 0, 0, 0.80)',
	textDarkSecondaryMain: 'rgba(255,255,255,0.60)', 
	// '#B3B4BA',
	textLightSecondaryMain: 'rgba(0,0,0,0.70)',
	textDarkTerciaryMain: '#ABCDFF',
	textLightTerciaryMain: Colors.awesomeRed,

	bgDarkPaper: '#222233',
	bgLightPaper: '#eaeaea',
}


export default Theme;
